import { JSX, ReactNode } from 'react'

import { Menu, Portal, MenuSelectionDetails } from '@chakra-ui/react'

import { RxDotsVertical } from 'react-icons/rx'





// eslint-disable-next-line @typescript-eslint/naming-convention
export function Icon (): JSX.Element
{
	return (
		<RxDotsVertical />

	)

}

export { MenuItem as Item } from '@chakra-ui/react'

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Root
(
	props: {
		icon    : JSX.Element
		children: ReactNode

		active?(v: string): void

	},

)
:	JSX.Element
{
	let on_select = (details: MenuSelectionDetails) : void =>
	{
		props.active?.(details.value)

	}

	return (
		<Menu.Root size="md" onSelect={on_select}>
			<Menu.Trigger cursor="pointer">{props.icon}</Menu.Trigger>

			<Portal>
				<Menu.Positioner>
					<Menu.Content>{props.children}</Menu.Content>

				</Menu.Positioner>

			</Portal>

		</Menu.Root>

	)

}
